<div class="modal-heading">
    <div class="close-button invisible"></div>
    <div class="header-text">Worker Details</div>
    <div class="close-button" style="color: var(--text-primary);" (click)="closeDialog()">
        <mat-icon class="close-icon">close</mat-icon>
    </div>
</div>
<div class="modal-body">
    <div class="table-container">
        <table class="table">
            <thead class="table-head">
                <tr>
                    <th>
                        <span>Worker Name</span>
                    </th>
                    <th>
                        <span>Phone Number</span>
                    </th>
                    <th>
                        <span>Worker FC</span>
                    </th>
                </tr>
            </thead>
            <tbody>
                @for(item of workerData; track item){
                <tr>
                    <td data-label="Worker Name">{{item.worker_name}}</td>
                    <td data-label="Phone Number">{{item.worker_contact_number || '-'}}</td>
                    <td data-label="Worker FC">{{item.worker_fc}}</td>
                </tr>
            }
            </tbody>
        </table>
    </div>            
</div>
